// Resolve the backend base URL from environment configuration.
// - REACT_APP_IS_IT_PRODUCTION_VERSION === 'false' -> local backend
// - otherwise                                      -> deployed (prod) backend
// When the flag is unset we default to the local backend rather than a
// hardcoded host, so a missing .env never silently points at a stale server.
const productionFlag = process.env.REACT_APP_IS_IT_PRODUCTION_VERSION;
const isLocal = productionFlag === 'false' || productionFlag === undefined;

export const API_URL = isLocal
  ? process.env.REACT_APP_API_URL_LOCAL
  : process.env.REACT_APP_API_URL_PROD;
